"use strict";
exports.__esModule = true;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
function LoadableImg(_a) {
    var onLoad = _a.onLoad, props = tslib_1.__rest(_a, ["onLoad"]);
    var imgRef = react_1["default"].useRef(null);
    var onLoadRef = react_1["default"].useRef(onLoad);
    onLoadRef.current = onLoad;
    react_1["default"].useEffect(function () {
        var imgEl = imgRef.current;
        if (!imgEl) {
            return;
        }
        if (imgEl.complete) {
            onLoadRef.current(imgEl);
            return;
        }
        imgEl.onload = function () {
            onLoadRef.current(imgEl);
            imgEl.onload = null;
        };
    }, []);
    return react_1["default"].createElement("img", tslib_1.__assign({}, props, { ref: imgRef }));
}
exports["default"] = LoadableImg;
